import { Row } from 'shared';
import styled from 'theme';

export const LayoutWrapper = styled(Row)`
  flex-flow: column;
  height: 100%;
  min-height: 100vh;
  z-index: 0;
`;
